import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import BoxLayoutContent from "@/shared/components/layout/boxLauotContent";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import MapView, { Location } from "@/shared/components/common/map";
import Content from "./content";
import { Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { fetchMapgishe } from "@/api/user/home";
import BoxKit from "@/shared/components/kit/box";
import ContentSkeleton from "../../walletReports/content.skeleton";
/**
 * LocationMerchant
 *
 * صفحه لیست مراکز پذیرنده همراه با نمایش موقعیت روی نقشه.
 *
 * - بارگذاری داده‌های مراکز با استفاده از `react-query` و `fetchMapgishe`.
 * - فیلتر و تبدیل داده‌ها به نقاط قابل نمایش روی کامپوننت `MapView`.
 * - نمایش لیست پذیرنده‌ها از طریق کامپوننت `Content`.
 * - شامل هدر با آیکون موقعیت و عنوان.
 * - نمایش نقشه با نقاط مراکز پذیرنده.
 *
 * @returns JSX.Element
 */

const LocationMerchant = () => {
  const { data: dataLocation, isLoading } = useQuery({
    queryKey: ["merchant-list-dataPayment"],
    queryFn: fetchMapgishe,
  });
  let points: Location[] = [];
  if (dataLocation && Array.isArray(dataLocation)) {
    points = dataLocation
      .filter((item) => item.latitude && item.longitude && !isNaN(Number(item.latitude)) && !isNaN(Number(item.longitude)))
      .map((item) => ({ name: `${item.address}`, lat: Number(item.latitude), lng: Number(item.longitude), }));
  }
  return (
    <StackKit
      spacing={2}
      direction={'column'}
      gap={2}
      sx={{
        px: { xs: 1, sm: 2, md: 4 }, // Responsive horizontal padding
        py: { xs: 2, sm: 3 }, // Responsive vertical padding
      }}
    >
      {/* Header Section */}
      <BoxLayoutContent sxStyle={{ background: "linear-gradient(97.77deg, rgba(0, 0, 0, 0.4) -9.73%, rgba(23, 23, 23, 0.281106) 16.04%, rgba(115, 103, 240, 0.25) 50.23%, rgba(65, 65, 65, 0.231942) 87.66%, rgba(0, 0, 0, 0.16) 109.42%)", borderRadius: "12px", p: { xs: 2, sm: 3, md: 4 }, }}
        titleElement={
          <StackKit direction={"row"} alignItems={{ xs: "flex-start", sm: "center" }} spacing={1}>
            <TypoGraphyKit variant="h6" sx={{ fontSize: { xs: "1rem", sm: "1.2rem", md: "1.4rem" } }}>
              <LocationOnOutlinedIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
            </TypoGraphyKit>
            <TypoGraphyKit variant="h6" sx={{ fontSize: { xs: "1rem", sm: "1.2rem", md: "1.4rem" } }}>
              لیست مراکز پذیرنده
            </TypoGraphyKit>
          </StackKit>
        }
      >
        {isLoading ?
          <ContentSkeleton />
          :
          <Content dataLocation={dataLocation} />
        }
      </BoxLayoutContent>

      {/* Map Section */}
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <BoxKit sx={{ width: "100%", height: { xs: 300, sm: 400, md: 500 }, borderRadius: "10px", overflow: "hidden", }}>
            <MapView locations={points} />
          </BoxKit>
        </Grid>
      </Grid>
    </StackKit>

  );
};

export default LocationMerchant;
